<template>
  <div>
    <ExpandableSettingsItem :title="$t('message.ACTION_PLANS')" use-transition-expand default-expand>
      <div>
        <div class="generic-background">
          <SettingsActionPlanList />
        </div>
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.DISPLAY_NOUN')" use-transition-expand>
      <div>
        {{ $t('message.N_DB_ACTIONS_LINES') }}<br>
        <InputNumber
          :value="currentTeam.planActionLines"
          class="settings-input settings-db-digit"
          @input="saveParams('planActionLines', $event)"
        />
        <div>
          <IntCheckbox
            :value="currentTeam.displayActionGain"
            :title="$t('message.DISPLAY_GAIN')"
            @input="saveParams('displayActionGain', $event)"
          />
        </div>
      </div>
    </ExpandableSettingsItem>
  </div>
</template>

<script>
/**
 * Team's actions settings.
 * This is the settings page to manage the settings related to Shizen actions for this team.
 */

// Components
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import InputNumber from '@/components/input-number.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
import SettingsActionPlanList from '@/components/settings-action-plan-list.vue';
// Vuex utils
import { SET_TEAM_PARAM } from '@/store/action-types';

export default {

  name: 'SettingsActions',

  components: {
    ExpandableSettingsItem,
    InputNumber,
    IntCheckbox,
    SettingsActionPlanList,
  },

  data() {
    return {
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS_ACTIONS'),
    };
  },

  methods: {
    /** Save team's params */
    saveParams(field, value) {
      this.$store.dispatch(SET_TEAM_PARAM, { ...this.defaultParams, [field]: value });
    },
  },
};
</script>
